export default "/images/blanko-mobile-871x1764.png?2cacd2608a32275994bcfbfcfb1a74d6";